<div class="go-to-link" [class.mobile]="mobileService.isMobile">
    <div>{{goToLinkText}}</div>
</div>